import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { AutenticacionService } from 'src/app/services/autenticacion.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { FormUtils } from 'src/app/shared/utils/form-utils';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { Usuario } from 'src/app/models/entities/usuario';
import { TransaccionEnum } from 'src/app/shared/enums/transaccion.enum';
import { UsuarioSesionDTO } from 'src/app/models/dtos/usuario-sesion-dto';
import { RegistroUsuarioDTO } from 'src/app/models/dtos/registro-usuario-dto';
@Component({
  selector: 'registro-usuario',
  templateUrl: './registro-usuario.component.html',
  styleUrls: ['./registro-usuario.component.scss'],
  animations: [
    trigger('fadeIn', [
      state('in', style({ opacity: 1 })),
      transition(':enter', [
        style({ opacity: 0 }),
        animate(300)
      ]),
      transition(':leave',
        animate(300, style({ opacity: 0 })))
    ])
  ]
})
export class RegistroUsuarioComponent implements OnInit {

  public registroForm: FormGroup;
  public anioActual = new Date().getFullYear();
  public idiomaCalendario: any;

  constructor(
    private formBuilder: FormBuilder,
    private autenticacionService: AutenticacionService,
    public formUtils: FormUtils,
    public dateUtils: DateUtils
  ) { }

  ngOnInit() {
    this.inicializarForm();
    this.idiomaCalendario = this.dateUtils.idiomaEspanol;
  }

  private inicializarForm(): void {
    this.registroForm = this.formBuilder.group({
      nombre: new FormControl('', [Validators.required]),
      primerApellido: new FormControl('', [Validators.required]),
      segundoApellido: new FormControl('', [Validators.required]),
      correo: new FormControl('', [Validators.required, Validators.email]),
      telefono: new FormControl(''),
      fechaNacimiento: new FormControl(''),
      contrasena: new FormControl('', [Validators.required, Validators.minLength(6)]),
      confirmarContrasena: new FormControl('', [Validators.required, Validators.minLength(6)])
    });
  }

  public async registrarUsuario(): Promise<any> {
    let usuario: RegistroUsuarioDTO = {
      ...this.registroForm.value,
      fechaNacimiento: new Date().getTime(),
      fechaCreacion: new Date().getTime(),
      fechaActualizacion: new Date().getTime()
    };
    let transaccion: TransaccionEnum = await this.autenticacionService.registrarUsuario(usuario);
    if (transaccion === TransaccionEnum.EXITOSA) {
      this.inicializarForm();
    }
  }


}
